import React from 'react';
import { Card, CardBody } from 'reactstrap';

// Shown when a role reaches a screen its permissions do not cover — either
// because a deep link bypassed the nav gating, or because the ACL cached at
// login has since been revoked and the server answered 403.
const AccessDenied = ({
  title = 'You do not have access to this page',
  body = 'Your role does not include permission to view this. Ask an administrator if you need it.',
}) => (
  <Card>
    <CardBody
      style={{
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <i
        className="now-ui-icons ui-1_lock-circle-open"
        style={{ fontSize: '48px', color: '#9a9a9a', marginBottom: '20px' }}
      />
      <h5>{title}</h5>
      <p className="text-muted" style={{ maxWidth: '440px' }}>
        {body}
      </p>
    </CardBody>
  </Card>
);

export default AccessDenied;
